<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>Busca Ativa — Turmas com Incidência</h1>
        <span class="text-body-2 grey--text">Todas as turmas com alunos em risco de evasão.</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="4">
        <e-label>Escola</e-label>
        <e-autocomplete
          :items="escolas"
          :item-text="(escola) => escola.descricao"
          :item-value="(escola) => escola.id"
          v-model="escolaId"
          @change="carregar()"
          placeholder="Todas as escolas"
          clearable
          dense
          solo
          hide-details
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-alert v-if="!carregando && !turmas.length" type="info" text border="left">
          Nenhuma turma com aluno em risco de evasão.
        </v-alert>
        <v-expansion-panels :key="chaveDosPaineis" v-model="paineisAbertos" multiple accordion flat>
          <v-expansion-panel
            v-for="turma of turmas"
            :key="turma.turma_id"
            class="mb-3 rounded border"
          >
            <v-expansion-panel-header>
              <div class="d-flex align-center flex-wrap" style="gap: 8px">
                <span class="text-subtitle-1 font-weight-bold primary--text">{{
                  turma.turma
                }}</span>
                <span class="text-caption grey--text">
                  {{ turma.escola }}<template v-if="turma.turno"> — {{ turma.turno }}</template>
                </span>
                <v-spacer />
                <v-chip
                  v-for="categoria of turma.por_categoria"
                  :key="categoria.categoria"
                  :color="corDaCategoria(categoria.categoria)"
                  :dark="!temTextoEscuro(categoria.categoria)"
                  x-small
                  label
                >
                  {{ categoria.quantidade }} {{ categoria.rotulo }}
                </v-chip>
                <v-chip x-small label outlined>
                  {{ turma.qtd_em_risco }}
                  {{ turma.qtd_em_risco === 1 ? "aluno em risco" : "alunos em risco" }}
                </v-chip>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <e-tabela-alunos-em-risco :casos="turma.alunos" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <e-paginate
          v-if="paginacao.last_page > 1"
          :key="`paginacao-${escolaId || 'todas'}`"
          :current_page="paginacao.current_page"
          :last_page="paginacao.last_page"
          :pageNumber="paginacao.current_page"
          search=""
          @changeActionResponse="carregar"
        />
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
import ETabelaAlunosEmRisco from "@/components/BuscaAtiva/ETabelaAlunosEmRisco.vue";
import { CORES_RISCO, temTextoEscuro } from "@/components/BuscaAtiva/EChipRiscoEvasao.vue";

export default {
  components: { ETabelaAlunosEmRisco },
  data() {
    return {
      turmas: [],
      escolas: [],
      escolaId: null,
      paginacao: { current_page: 1, last_page: 1, total: 0 },
      paineisAbertos: [],
      carregando: false,
    };
  },
  computed: {
    chaveDosPaineis() {
      return `${this.escolaId || "todas"}-${this.paginacao.current_page}`;
    },
  },
  async mounted() {
    this.$loaderService.open("Carregando as turmas com incidência");
    try {
      await Promise.all([this.carregarEscolas(), this.carregar()]);
    } finally {
      this.$loaderService.close();
    }
  },
  methods: {
    temTextoEscuro,
    async carregarEscolas() {
      try {
        const opcoes = await this.$services.buscaAtivaService.opcoesDeFiltro();
        this.escolas = opcoes.escolas;
      } catch (error) {
        this.$handleError(error);
      }
    },
    async carregar(pagina = 1) {
      this.carregando = true;
      try {
        const resposta = await this.$services.buscaAtivaService.turmasComIncidencia({
          escola_id: this.escolaId,
          page: pagina,
        });
        this.turmas = resposta.data;
        this.paginacao = resposta.meta ?? this.paginacao;
        this.paineisAbertos = this.turmas.map((_, indice) => indice);
      } catch (error) {
        this.$handleError(error);
      }
      this.carregando = false;
    },
    corDaCategoria(categoria) {
      return CORES_RISCO[categoria] ?? "grey";
    },
  },
};
</script>

<style scoped>
.border {
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
